const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Games",
    xmlns: "http://www.w3.org/2000/svg",
    width: "169.7mm",
    height: "107.98mm",
    viewBox: "0 0 481.03 306.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M363.2,72.99h-48.41c-11.11,0-21.34,5.75-27.36,15.08-8.12,12.56-26.07,21.3-46.91,21.3s-38.79-8.73-46.91-21.3c-6.03-9.33-16.26-15.08-27.36-15.08h-48.41c-64.31,0-117.45,51.55-117.82,115.86s52.05,117.22,116.54,117.22h21.28c18.53,0,35.7-10.49,43.48-27.31,10.33-22.37,32.96-37.89,59.22-37.89s48.89,15.52,59.22,37.89c7.77,16.83,24.94,27.31,43.48,27.31h21.28c64.49,0,116.91-52.65,116.54-117.22s-53.51-115.86-117.82-115.86Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.87,182.54h-59.1v-59.1c0-3.87-3.13-7-7-7s-7,3.13-7,7v59.1h-59.1c-3.87,0-7,3.13-7,7s3.13,7,7,7h59.1v59.1c0,3.87,3.13,7,7,7s7-3.13,7-7v-59.1h59.1c3.87,0,7-3.13,7-7s-3.13-7-7-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.41,
    cy: 150.84,
    r: 21.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.7,
    cy: 228.23,
    r: 21.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.11,
    cy: 228.23,
    r: 21.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,119.37c-5.52,0-10-4.48-10-10v-35.03c0-17.11,13.92-31.03,31.03-31.03h3.57c6.08,0,11.03-4.95,11.03-11.03s-4.95-11.03-11.03-11.03h-119.56c-5.52,0-10-4.48-10-10s4.48-10,10-10h119.56c17.11,0,31.03,13.92,31.03,31.03s-13.92,31.03-31.03,31.03h-3.57c-6.08,0-11.03,4.95-11.03,11.03v35.03c0,5.52-4.48,10-10,10Z",
    style: {
      fill: "#133c46"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.3fb5c0b64c4e024b1afae2e31ff47756.svg";
export { ForwardRef as ReactComponent };